import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import MyAccountLayout from "@/components/MyAccountLayout"
import { useState, useEffect } from "react"
import styles from "@/styles/my-account/credits.module.scss"
import myAccountApi from '@/service/modules/myAccountApi'
import couponApi from '@/service/modules/couponApi'
import { Button, Input, Space, Table, message } from 'antd';
import Link from 'next/link'
import Image from 'next/image'
import dayjs from 'dayjs'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function MyaccountStatus() {

  const [credits, setCredits] = useState({ credits: 0, points: 0 })
  const [used, setUsed] = useState({ usedCredits: 0, usedPoints: 0 })
  const [dataSource, setDataSource]: any = useState()
  const [pointValue, setPointValue] = useState("")
  const [isShowCouponConditions, setIsShowCouponConditions] = useState(false)

  const getCreditsList = async () => {
    try {
      let res = await myAccountApi.creditsList()
      if (res.data) {
        const { credits, used } = res.data
        setCredits(credits)
        setUsed(used)
        const pointArr = [
          {
            key: '1',
            crazyPoints: credits.points,
            usedPoints: used.usedPoints,
            currencyValue: credits.currencyValue
          }
        ]
        setDataSource(pointArr)
      }
    } catch (error) {
      console.error(error)
    }
  }

  interface CouponItem {
    id: string;
    name: string;
    link: string;
    available: number;
    limitProduct: string;
    dateLeft: number;
    dateLeftText: string;
    amountLimit: string;
    amountLimitOff: string;
    startTime: number;
    expiredTime: string;
  }
  // const [couponCount, setCouponCount] = useState(0)
  const [couponList, setCouponList] = useState<CouponItem[]>([])


  const getCouponList = async () => {
    try {
      let res = await couponApi.getCouponList({})
      if (res.data && res.data.coupons && res.data.coupons.total) {
        // setCouponCount(res.data.coupons.total)
        setCouponList(res.data.coupons.items || [])
      }
    } catch (error) {
      console.error(error)
    }
  }


  useEffect(() => {
    getCreditsList()
    getCouponList()
  }, [])

  const columns = [
    {
      title: 'BestDealsPoints',
      dataIndex: 'crazyPoints',
      key: '1',
      render: (text: string, record: any) => (
        <>
          <span>{text}</span>&nbsp;=&nbsp;<span style={{ color: '#e6415f' }}>${record.currencyValue}</span>
        </>
      ),
      align: 'center' as 'center'
    },
    {
      title: 'Used Points',
      dataIndex: 'usedPoints',
      key: '2',
      align: 'center' as 'center'
    }
  ];

  const applyNow = async () => {
    try {
      let res = await myAccountApi.applyVoucher({ voucher: pointValue })
      if (res.data) {
        message.success("Successful")
      }
    } catch (error: any) {
      message.error(error.message)
    }
  }

  return (
    <>
      <Head>
        <title>
          Credit & Points - My Account - BestDeals.co.nz
        </title>
      </Head>

      <DefaultLayout>
        <MyAccountLayout>
          {
            !isShowCouponConditions &&
            <div className={styles['my-credits-status']}>
              <div className={styles['main-title']}>Credits & BestDealsPoints</div>

              <div className={styles['heading']}>
                <div className={styles['head']}>Credits</div>
              </div>

              <div className={styles['credits-box']}>
                <div className={styles['current']}>
                  <div className={styles['point']}>{credits.credits}</div>
                  <div className={styles['desc']}>Current Credits</div>
                </div>
                <div className={styles['used']}>
                  <div className={styles['point']}>{used.usedCredits}</div>
                  <div className={styles['desc']}>Used Credits</div>
                </div>
                <div className={styles['voucher']}>
                  <div className={styles['title']}>Voucher Code:</div>
                  <Space.Compact style={{ width: '100%' }}>
                    <Input onChange={(e) => { setPointValue(e.target.value) }} width={215} />
                    <Button disabled={!pointValue} style={pointValue ? { backgroundColor: '#446CB3', color: '#fff', borderRadius: '0' } : { borderRadius: '0' }} onClick={applyNow}>Apply Now</Button>
                  </Space.Compact>
                </div>
              </div>

              <div className={styles['introduce']}>
                <h3 className={styles['title']}>What are credits?</h3>
                <p className={styles['desc']}>
                  Enter in voucher code and then click Apply Now above. Credits will be added to your account credit.
                  <br />1 credit=$1 and may be used during checkout.
                </p>
              </div>

              <div className={styles['heading']}>
                <div className={styles['head']}>BestDealsPoints</div>
                {/* <div className={styles['help']} >
                  <Link
                    href='/article/faq'
                    legacyBehavior
                  >
                    <a className={styles['href']} rel="noopener noreferrer">All BestDealsPoints & Coupon Help</a>
                  </Link></div> */}
              </div>

              <div className={styles['crazyPoints-box']}>
                <Table columns={columns} dataSource={dataSource} pagination={{ hideOnSinglePage: true }} bordered />
                <div className={styles['currently']}>
                  <p style={{ color: '#e6415f' }}>{`Currently, 100 BestDealsPoints equate to NZD $1.`}</p>
                  <p>{`e.g. (Your BestDealsPoints) x 0.01 = NZD $ Value.`}</p>
                </div>
              </div>

              <div className={styles['introduce']}>
                <h3 className={styles['title']}>What are BestDealsPoints?</h3>
                <p className={styles['desc']}>
                  Every dollar you spend at BestDeals (excluding shipping costs) earns you one BestDealsPoint. These points are like bonus savings for greater discounts on future purchases. When checking out, you can redeem your earned points to save more. Earn enough points and get items for FREE!
                  <Link href={"/article/faq"} legacyBehavior>
                    <a rel="noopener noreferrer" style={{ color: '#319EFF', textDecoration: "underline" }}>Help</a>
                  </Link>
                </p>
              </div>

              {/* <div className={styles['heading']}>
                <div className={styles['head']}>Coupon</div>
                <div className={styles['help']} >
                  <div 
                    className={styles['href']}
                    onClick={() => { 
                      setIsShowCouponConditions(true), 
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                      })
                    }}
                  >Coupon Terms & Conditions</div>
                </div>
              </div> */}

              {/* <div className={styles['coupon-nav']}>
                <div className={styles['nav-item']}>
                  <div className={styles['item-name']}>Valid Coupon</div>
                  <div className={styles['badge']}>{couponList.length || 0}</div>
                  <div className={styles['item-active']}></div>
                </div>
              </div> */}

              {/* <div className={styles['coupon-tips']}>
                Coupons issued by CRAZYSALES can only be used to deduct the payable amount for goods (excluding shipping fees)<br />
                The coupon cannot be used for pre-sale items.
              </div> */}

              {/* <div className={styles['coupon-list']}>
                {
                  couponList.map((item: CouponItem) => 
                    <div className={styles['coupon-item']} key={item.id}>
                      <div 
                        className={styles['coupon-header']} 
                        style={{ backgroundImage: `url(${imageDomain}/coupon/coupon-bg.png)` }}
                      >
                        <div className={styles['coupon-name']}>{`Any > $${item.amountLimit || 0} ORDER`}</div>
                        <div className={styles['coupon-price']}>${item.amountLimitOff}</div>
                        <div className={styles['coupon-days-left-box']}>
                          <div className={styles['coupon-days-left']}>{item.dateLeftText}</div>
                        </div>
                        <div className={styles['coupon-date']}>Ends {dayjs(item.expiredTime).format('DD/MM/YYYY')}</div>
                      </div>
                      <div className={styles['coupon-bottom']}>
                        <div className={styles['coupon-limit']}>
                          Coupon excludes shipping
                        </div>
                        <div className={styles['coupon-product-scope']}>
                          { item.limitProduct ? 'Selected Products' : 'Sidewide' }
                        </div>

                        <Button 
                          size={'small'}
                          href={item.link}
                          className={`${styles['apply-btn']} coupon-apply-now`} 
                        >
                          Shop Now
                        </Button>
                      </div>
                    </div>
                  )
                }
              </div> */}

              <div className={styles['config-box']}>
                <Button href="/" className={styles['continue-shopping-btn']} type="primary">Continue Shopping</Button>
              </div>
            </div>
          }

          {
            isShowCouponConditions &&
            <div className={styles['my-credits-status']}>
              <div className={styles['main-title']}>Credits & Points</div>

              <div className={styles['heading']}>
                <div className={styles['head']}>Coupon Terms & Conditions</div>
              </div>

              <div className={styles['condition-text']}>
                <strong>Q1: What are the rules for using coupons?</strong><br></br>
                <strong>A: </strong>
                (1) Coupons issued by CRAZYSALES can only be used to deduct the payable amount for goods (excluding shipping fees) when placing an order at CRAZYSALES. They cannot be used more than once. No cash refunds are given. And they cannot be cashed out, transferred, or used for any other purpose.<br></br>
                (2) Only one coupon can be used per order. If an order placed with a coupon is cancelled, the system will not return the corresponding coupon.<br></br>
                (3) After using a coupon and confirming receipt of the goods, if a return occurs during the post-sale period, the system will divide the actual payment based on the proportion of the product&apos;s sale price to the total order amount. The coupon will not be refunded.<br></br>
                (4) CRAZYSALES reserves the right to the final interpretation of the coupon usage rules.<br></br>
                (5) The coupon cannot be used for pre-sale items.
              </div>

              <div className={`${styles['condition-text']} padding-top-26`}>
                <strong>Q2: Where can I view the coupons and how do I use them?</strong><br></br>
                <strong>A: </strong> Viewing Coupons: After logging in, go to the
                <strong>[my account]</strong>&nbsp;-&nbsp;
                <strong
                  style={{ color: '#319EFF', cursor: 'pointer' }}
                  onClick={() => {
                    setIsShowCouponConditions(false),
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                      })
                  }}>[Credits & Points] </strong>
                page.<br></br>
                Here you can see the name, validity period, terms of use, and applicable products for the coupons acquired.<br></br>
                Using Coupons: For coupons that have not expired, you can click the &quot;Shop Now&quot; button on the coupon to select products. If the amount of the product meets the conditions, the system will automatically select the coupon with the greatest discount, or you can manually choose any other coupon you want to enjoy the discount.
              </div>

              <div className={styles['conditions-image-box']}>
                <Image
                  className={`${styles['image-item']} margin-top-12`}
                  alt={'conditions'}
                  width={832}
                  height={442}
                  src={`${imageDomain}/coupon/condition-1.png`} />

                <Image
                  className={`${styles['image-item']} margin-top-12`}
                  alt={'conditions'}
                  width={832}
                  height={442}
                  src={`${imageDomain}/coupon/condition-2.png`} />

                <Image
                  className={`${styles['image-item']} margin-top-12`}
                  alt={'conditions'}
                  width={832}
                  height={442}
                  src={`${imageDomain}/coupon/condition-3.png`} />
              </div>

              <div className={`${styles['condition-text']} padding-top-26`}>
                <strong>Q3: If the value of the coupon exceeds the price of the product, will the difference be reimbursed to me?</strong><br></br>
                <strong>A: </strong>
                No. If the value of the coupon exceeds the price of the product, the difference will not be refunded or reimbursed in any form. The excess amount will be forfeited after payment is made.
              </div>

              <div className={`${styles['config-box']} padding-top-20`}>
                <Button
                  onClick={() => {
                    setIsShowCouponConditions(false),
                      window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                      })
                  }}
                  className={styles['view-coupon-btn']}
                >
                  View Coupon
                </Button>
                <Button
                  href="/"
                  className={styles['continue-shopping-btn']}
                  type="primary"
                >
                  Continue Shopping
                </Button>
              </div>
            </div>
          }

        </MyAccountLayout>
      </DefaultLayout>
    </>
  )
}